import { DXP_SSO_MARKER } from '../auth/dxp-sso';
import getAppConfig from './get-app-config';

interface AuthState {
  isAuthenticated: boolean;
  [key: string]: unknown;
}

interface AccessToken {
  accessToken: string;
  [key: string]: unknown;
}

interface Tokens {
  accessToken: AccessToken;
  [key: string]: unknown;
}

interface DecodedToken {
  payload: {
    cid: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

interface OktaAuth {
  tokenManager: {
    getTokens: () => Promise<Tokens>;
  };
  token: {
    decode: (token: string) => DecodedToken;
  };
}

const transformAuthState = async (oktaAuth: OktaAuth, authState: AuthState): Promise<AuthState> => {
  if (!authState.isAuthenticated) {
    return authState;
  }

  // Safari SSO: tokens adopted from the DXP shared cookies are minted for the
  // parent (MyCargill) client, so their `cid` won't match this app's clientId.
  // The onboarding backend still accepts them, so skip the equality check here.
  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(DXP_SSO_MARKER)) {
    return authState;
  }

  const tokens = await oktaAuth.tokenManager.getTokens();
  const accessTokenDecoded = oktaAuth.token.decode(tokens.accessToken.accessToken);
  const activeAppOktaClientId = getAppConfig().oktaOIDC.clientId;
  if (accessTokenDecoded && activeAppOktaClientId && activeAppOktaClientId !== accessTokenDecoded.payload.cid) {
    authState.isAuthenticated = false;
  }

  return authState;
};

export default transformAuthState;
